<template>
  <div>
    <el-dialog
      :visible.sync="newDialog"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      class="dialog_modal dialog_800"
      :append-to-body="true"
      title=" Contact the selected companies"
    >
      <div class="dialog_content">
        <!-- <h4 class="Exportofflinetab margin-bottom20"><span :class="ExportofflinetabActive==0?'ExportofflinetabActiveSPan':''" @click="showCompanyCilick(0)">Downloadable</span><span :class="ExportofflinetabActive==1?'ExportofflinetabActiveSPan':''" @click="showCompanyCilick(1)">Downloaded</span> </h4> -->
        <div class="Exportoffline">
          <!-- <p style="margin-bottom: 10px; " class="flex_center_bettwen"><span>Found over {{ total}}: </span>   <el-button 
                :class="remouveFavorite.length == 0 ? ' btn_export btn_exporthui' : 'btn_exportred btn_export'"
                :disabled="remouveFavorite.length == 0" @click="CollectDelate">Remove</el-button></p> -->

          <el-table
            ref="treeTable"
            :key="refresh"
            :data="parentTable"
            empty-text="No Data"
            :border="true"
            cell-class-name="company line_1"
            height="100%"
            :row-key="(row) => row.aaa_id"
            class="table_box"
          >
            <el-table-column
              :label="$t('RatingAnalysis.SubjectCompany')"
              prop="company_name_en"
              align="left"
              class-name="company  "
              show-overflow-tooltip
              :resizable="true"
            >
              <template slot-scope="scope">
                <div class="line_1">
                  <!-- <div class="btn_expand" :class="{ expand_icon: scope.row.isExpand }"
                                                @click="onClickExpansion(scope.row)"></div> -->

                  <!-- <img @click="gotocountry(scope.row)" :src="scope.row.flag" /> -->
                  <div @click="setid(scope.row)" class="line_1">
                    {{
                      scope.row.companyName == "" ||
                      scope.row.companyName == undefined ||
                      scope.row.company_name_en == null
                        ? scope.row.companyName
                        : scope.row.companyName
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Number of Email"
              prop=""
              width="120"
              align="left"
              show-overflow-tooltip
              :resizable="true"
            >
              <template slot-scope="scope">
                <div class="line_1">
                  <!-- <div class="btn_expand" :class="{ expand_icon: scope.row.isExpand }"
                                                @click="onClickExpansion(scope.row)"></div> -->

                  <!-- <img @click="gotocountry(scope.row)" :src="scope.row.flag" /> -->
                  <div class="line_1">
                    {{ 1 }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Number of  Departments"
              prop=""
              width="130"
              align="left"
              show-overflow-tooltip
              :resizable="true"
            >
              <template slot-scope="scope">
                <div class="line_1">
                  <!-- <div class="btn_expand" :class="{ expand_icon: scope.row.isExpand }"
                                                @click="onClickExpansion(scope.row)"></div> -->

                  <!-- <img @click="gotocountry(scope.row)" :src="scope.row.flag" /> -->
                  <div class="line_1">
                    {{ 2 }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="margin-top20">
            <button
              @click="ConfirmClikc()"
              :disabled="NowUpdateList.length == 0"
              class="riskButton btn_export questionExportButtonactive"
            >
              Back
            </button>
            <!-- <button
              @click="ConfirmClikc()"
              :disabled="NowUpdateList.length == 0"
              style="
                background-color: #e7e5ff !important;
                color: #8e86dd !important;
              "
              class="btn_export riskButton margin-left30"
            >
              Cancel
            </button> -->
            <button
              @click="ConfirmClikc()"
              :disabled="NowUpdateList.length == 0"
              class="riskButton tijiao ExportofflinetabActive questionExportButtonactive margin-left30"
            >
              Please Call
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserConsumptionBatch } from "@/api/userApi";
import { mixins1 } from "@/mixins/index";
export default {
  props: {
    suoClose: {
      type: Boolean,
      //   default: false,
    },
    obj: {
      type: Object,
    },
    update: {
      type: Object,
    },
    ComapnyName: {
      type: String,
    },
    Saved: {
      type: Number,
    },
  },
  mixins: [mixins1],
  data() {
    return {
      checkAll: false,
      ExportofflinetabActive: 0,
      isIndeterminate: true,
      UpdateEndDialog: false,
      uPdateDialog: false,
      refresh: 0,
      parentTable: [],
      pageNo: 0,
      lastUpdateList: [],
      NowUpdateList: [],
      total: 0,
      remouveFavorite: [],
      token: sessionStorage.getItem("token"),
    };
  },
  computed: {
    newDialog: {
      get() {
        return this.suoClose;
      },
      set() {},
    },
  },
  destroyed() {
    // bus.$off('handleShowLogin');
  },
  mounted() {},
  watch: {
    newDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getShouCompanyList();
        }

        // 在这里处理Sort属性的变化
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },

  methods: {
    getShouCompanyList() {
      let Updatelis = [];

      this.$store.state.app.changeList.map((item) => {
        Updatelis.push({
          countryCode: item.company_country,
          companyName: item.company_name_en,
          companyAaaid: item.aaa_id,
        });
      });
      getUserConsumptionBatch(Updatelis).then((res) => {
        if (res.code == 200) {
          let that = this;

          this.lastUpdateList = [];
          this.NowUpdateList = [];
          res.data.map((item) => {
            if (item.consumptionStatus == 1) {
              that.lastUpdateList.push(item);
            }
            if (item.consumptionStatus == 2) {
              that.NowUpdateList.push(item);
            }
          });
          if (this.ExportofflinetabActive == 0) {
            this.parentTable = this.NowUpdateList;
          } else {
            this.parentTable = this.lastUpdateList;
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 删除收藏
    showCompanyCilick(index) {
      this.ExportofflinetabActive = index;
      this.getShouCompanyList();
    },
    handleSelectionChange(val) {
      this.remouveFavorite = val;
    },

    UpdatecloseDialog() {
      this.UpdateEndDialog = false;
    },
    //关闭弹窗
    closeDialog() {
      this.$emit("closeSaveDialogtwo", false);
    },
    ConfirmClikc() {
      this.$emit("closeSaveDialogtwo", false);
      // this.$parent.uPdateDialog=true
    },
    onSubmitkoudian() {
      this.uPdateDialog = false;

      //  this.$emit('closeCloseDialog1', true);
    },
    // 全选
  },
};
</script>
<style scoped>
.Exportoffline {
  flex: 1;
  overflow: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
/deep/ .table_box .el-table th > .cell {
  padding-right: 15px !important;
}
.Exportofflinetab {
  display: flex;
  text-align: center;
  gap: 30px;
}
.Exportofflinetab span {
  line-height: 26px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  font-size: 18px;
}
.ExportofflinetabActive {
  flex: none;
  background: #8e86dd !important;
  color: #fff !important;
}
.ExportofflinetabActiveSPan {
  color: #685ed1 !important;
  border-bottom: 2px solid #685ed1;
}

button:disabled {
  background-color: #cccccc !important;
}
.company_list {
  flex: 1;
  height: 50vh;
}

@media screen and (max-width: 1920px) {
  .Exportofflinetab {
    gap: 22px;
  }
  .Exportofflinetab span {
    font-size: 16px;
    line-height: 20px;
  }
}
@media screen and (max-width: 1439px) {
  .Exportofflinetab {
    gap: 20px;
  }
}
</style>
